import { TruckType, VehicleProfilePlugTypes } from '../facade/facadeApiV3';
import { EmissionClass, HazardClass } from './vehicleProfileTypes';

export const DEFAULT_PROFILE_ID = '02bb3f45-0b1d-4a11-8f20-05fde3b1b966';
export const DEFAULT_FULL_BATTERY_CAPACITY = 100; // unit %
export const DEFAULT_MAX_BATTERY_CAPACITY = 80; // unit %
export const DEFAULT_MIN_BATTERY_CAPACITY = 20; // unit %

export const defaultVehicleProfile = {
    profileType: DEFAULT_PROFILE_ID,
    length: 0,
    height: 0,
    width: 0,
    totalWeight: 0,
    vehicleAxles: 1,
    trailerAxles: 0,
    emissionClassification: EmissionClass.EURO_IV,
    hazardClassification: HazardClass.NONE,
    payloadWeight: 0,
    averageOutdoorTemperature: 20,
    initSoC: DEFAULT_FULL_BATTERY_CAPACITY,
    minSoC: DEFAULT_MIN_BATTERY_CAPACITY,
    maxSoC: DEFAULT_MAX_BATTERY_CAPACITY,
    originSoC: 80,
    destinationSoC: 10,
    plugTypes: [VehicleProfilePlugTypes.Ccs, VehicleProfilePlugTypes.Mcs],
    costPerKm: 1.3,
    costPerKWh: 1.2,
    weightPerAxle: 1000,
    truckType: TruckType.Truck,
    currency: 'EUR',
};
